import Immutable from 'immutable'

export const ServiceDefinitionRecord = Immutable.Record({
  group: null,
  id: null,
  name: '',
  type: '',
}, 'ServiceServiceDefinition')

export default function createServiceServiceDefinition(data) {
  return new ServiceDefinitionRecord(data)
}



// WEBPACK FOOTER //
// ./deps/internal-components/src/records/Service/ServiceDefinition.js